// extracted by mini-css-extract-plugin
export default {"root":"_2Kth3","icon":"sW-H4","tooltip":"_1u2ys"};